<nav class="cvdp-quicknav d-print-none" *ngIf="visible" #bar aria-label="Tools">
  <ul class="cvdp-quicknav__list">
    <li class="cvdp-quicknav__item" *ngFor="let link of links; trackBy: trackByValue">
      <a class="cvdp-quicknav__link" [routerLink]="[link.route]"
        [class.cvdp-quicknav__link--active]="isActive(link)"
        [attr.aria-current]="isActive(link) ? 'page' : null"
        [attr.aria-label]="link.description">
        <i class="cvdp-quicknav__icon" [ngClass]="link.icon" aria-hidden="true"></i>
        <span class="cvdp-quicknav__label">{{ link.label }}</span>
      </a>
    </li>
  </ul>
</nav>
